import View from 'views/base/view';
import CustomContentTemplates from './templates';

const CustomContentView = View.extend({
  listen: {
    parentAddedToDOM: 'added',
  },
  initialize() {
    this.template = CustomContentTemplates[`custom-${this.model.get('content_type')}`];
    View.prototype.initialize.apply(this, arguments);
  },
  added() {
    if (this.model.get('content_type') === 'modal') {
      this.modal = this.$('#custom-modal');
      this.modal.modal('show');
      this.done = true;
      this.modal.on('hidden.bs.modal', () => this.model.set('done', true));
    } else {
      this.done = true;
      this.model.set('done', true);
    }
  },
});

export default CustomContentView;
